module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.10@core-js/modules/_library.js
// module id = 30
// module chunks = 29